import { useEffect, useState } from 'react';

import hooksConstants from 'src/constants/hooks.constants';
import { PULL_TO_LESSON_EVENT } from 'src/constants/realtime.constants';
import { RealtimePullToLessonPayload } from 'src/interfaces/api.types';
import realtimeService from 'src/services/realtime.service';

const isAllowedDomain = (url: string, allowedDomains: string[]) => {
  const urlDomain = new URL(url, window.location.href).hostname
    .split('.')
    .slice(-2)
    .join('.');

  return allowedDomains.includes(urlDomain);
};

// Custom hook to add listeners for pull-to-lesson events emitted from desmos-classroom
// will redirect to student.desmos.com based on realtime event payload after a 3s delay
export const useDesmosLesson = () => {
  let redirectTimeout: NodeJS.Timeout;
  const [isLoading, setIsLoading] = useState(false);

  const callback = (
    _eventType: typeof PULL_TO_LESSON_EVENT,
    payload: RealtimePullToLessonPayload,
  ): void => {
    const { url, sessionId } = payload;

    if (url && sessionId) {
      const isValidSessionId = url.includes(sessionId);
      // desmosdev.net - preview env for desmos-classroom
      // amplify.com for desmos devci and staging envs
      const isLinkSecure = isAllowedDomain(url, [
        'desmos.com',
        'desmosdev.net',
        'amplify.com',
      ]);

      if (isValidSessionId && isLinkSecure) {
        setIsLoading(true);
        redirectTimeout = setTimeout(
          () => window.location.assign(url),
          hooksConstants.LESSON_REDIRECT_LOADING_SCREEN_DELAY_MS,
        );
      }
    }
  };

  useEffect(() => {
    if (!realtimeService.hasInitialized) return;

    realtimeService.listenToDesmosPullToLesson(callback);

    return () => {
      clearTimeout(redirectTimeout);
      realtimeService.removeListenerForDesmosPullToLesson(callback);
    };
    // realtimeService.hasInitialized should be listed in deps array for correct subscription
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [realtimeService.hasInitialized]);

  return isLoading;
};
